/** The story log: newest line first, older lines fade, like A Dark Room's notifications. */
export interface Line {
  id: number;
  text: string;
}

const MAX = 18;

class Log {
  lines = $state<Line[]>([]);
  #id = 0;
  #last = new Map<string, number>();

  /** Adds a line. `throttleKey` limits a kind of message to one every few seconds. */
  say(text: string, throttleKey?: string): void {
    if (throttleKey) {
      const now = performance.now();
      if (now - (this.#last.get(throttleKey) ?? -Infinity) < 3500) return;
      this.#last.set(throttleKey, now);
    }
    this.lines = [{ id: ++this.#id, text }, ...this.lines].slice(0, MAX);
  }

  clear(): void {
    this.lines = [];
  }
}

export const log = new Log();
